import { Serializable } from '@/models/core/serializable';
import { store } from '@/store';

export class SchoolGroupPMAnalysis implements Serializable<SchoolGroupPMAnalysis> {
  analysisData: SchoolGroupPMAnalysisData[];
  analysisDescription: string;
  messageA: string;
  messageB: string;
  messageC: string;

  deserialize(input: any): SchoolGroupPMAnalysis {
    this.analysisData = input.analysisData.map((d: SchoolGroupPMAnalysisData) => new SchoolGroupPMAnalysisData().deserialize(d));
    this.analysisDescription = input.analysisDescription;
    this.messageA = input.messageA;
    this.messageB = input.messageB;
    this.messageC = input.messageC;
    return this;
  }
}

export class SchoolGroupPMAnalysisData implements Serializable<SchoolGroupPMAnalysisData> {
  student: any;
  xPos: number;
  yPos: number;

  deserialize(input: any): SchoolGroupPMAnalysisData {
    this.student = input.student;
    this.xPos = input.xPos;
    this.yPos = input.yPos;
    return this;
  }

  get fullName() {
    if (store.getters.isNameOrder) {
      // 日本語と同じ 姓 + 名
      return `${this.student.lastName} ${this.student.firstName}`;
    } else {
      // 日本語とは異なる 名 + 姓
      return `${this.student.firstName} ${this.student.lastName}`;
    }
  }
}
